import * as React from "react";
import { Component } from "react";
import "./ExpansionPanel.css";

interface IProps {
    OnClick?: () => void;
    Header: JSX.Element;
    ExpandedHeader?: JSX.Element;
    ExpansionPanelClass: string;
    PanelClass?: string;
    Expanded?: boolean;
}

interface IState {
    Expanded: boolean | undefined;
    Height?: number;
}


export class ExpansionPanel extends Component<IProps, IState> {
    private ChildrenRef;

    constructor(props) {
        super(props);

        this.state = {
            Expanded: this.props.Expanded ? this.props.Expanded : false,
            Height: 0
        };
    }

    public componentDidUpdate(prevProps: IProps) {
        if (prevProps.Expanded !== this.props.Expanded) {
            this.setState({
                Expanded: this.props.Expanded
            });
        }
    }

    public render() {
        return (
            <div className="expansion-panel">
                <div
                    onClick={this.props.OnClick ? this.OnClickOverride : this.ToggleExpansion}
                    className="expansion-panel__header">
                    {this.props.ExpandedHeader && this.state.Expanded ?
                        this.props.ExpandedHeader
                        :
                        this.props.Header
                    }
                </div>
                <div className={`expansion-panel__content ${this.state.Expanded ? this.props.ExpansionPanelClass : ""}`}
                    style={{ minHeight: this.state.Expanded || this.props.Expanded ? `${this.state.Height}px` : "0", height: this.props.Expanded ? 'auto' : 0 }}>
                    <div
                        className={`${this.props.PanelClass}`}
                        ref={(elem) => this.ChildrenRef = elem}>
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }

    private OnClickOverride = () => {
        if (this.props.OnClick) {
            this.props.OnClick();
        }
        this.SetHeight();
    }

    private ToggleExpansion = () => {
        this.setState({
            Expanded: !this.state.Expanded,
        })
        this.SetHeight();
    }

    private SetHeight = () => {
        this.setState({
            Height: this.ChildrenRef.clientHeight
        })
    }


}



// WEBPACK FOOTER //
// ./src/controls/ExpansionPanel.tsx